//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class PayPalMembershipSubscriptionInputItem extends ItemBase {
    MembershipPlanID: string | null = null;
    ReturnUrl: string | null = null;
    CancelReturnUrl: string | null = null;

    constructor(initializer?: Partial<PayPalMembershipSubscriptionInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PayPalMembershipSubscriptionInputItem";
}
